import React from 'react';
import PropTypes from "prop-types";
import {Form} from "react-bootstrap";

function TextArea(props) {
    props.elementProps.onBlur = function (e) {
        props.setAnswer(e.target.value)
    }
    props.elementProps.value = props.defaultValue
    props.elementProps.direction = "column"
    props.elementProps.alignItems = "start"
    return (<Form.Control as="textarea" type="text" {...props.elementProps} />)
}
TextArea.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setAnswer: PropTypes.func,
    onFocus: PropTypes.func,
    clean: PropTypes.func
};
export default TextArea;